var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"value":_vm.value,"hide-footer":!_vm.canBeUpdated || _vm.currentTab != 'general'},on:{"close":function($event){return _vm.close()},"ok":function($event){return _vm.submit($event)}},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('Header')]},proxy:true}])},[_c('b-overlay',{attrs:{"show":_vm.loading || _vm.loadingReservation,"no-wrap":"","rounded":""}}),_c('CreatedInfo',{staticClass:"mb-2",attrs:{"modelId":_vm.modelId,"copyFromId":_vm.copyFromId,"isCancelable":_vm.isCancelable},on:{"onCopyRes":function($event){return _vm.$emit('onCopyRes', $event)}}}),_c('TabsContainer',{on:{"activate-tab":_vm.activeIndex}},[_c('b-tab',{attrs:{"title":"General","active":""}},[_c('form',{ref:"resForm",attrs:{"action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('TabGeneral',{attrs:{"tsSelectedId":_vm.tsSelectedId,"modelId":_vm.modelId,"canBeUpdated":_vm.canBeUpdated,"copyFromId":_vm.copyFromId,"formTypeWork":_vm.formTypeWork}})],1)]),(
				_vm.viewModel.id > 0 && _vm.$hasPermission('reservation.cost.show')
			)?_c('b-tab',{attrs:{"title":"Costos"}},[(
					_vm.loadedIndex.includes(
						_vm.$hasPermission('reservation.cost.show') ? 1 : 0
					)
				)?_c('TabPrices',{attrs:{"model-id":_vm.viewModel.id}}):_vm._e()],1):_vm._e(),(
				_vm.viewModel.id > 0 &&
					_vm.$hasPermission('reservation.payment.show')
			)?_c('b-tab',{attrs:{"title":"Pagos"}},[(
					_vm.loadedIndex.includes(
						_vm.$hasPermission('reservation.payment.show') ? 2 : 1
					)
				)?_c('TabPayments',{attrs:{"model-id":_vm.viewModel.id}}):_vm._e()],1):_vm._e(),(_vm.viewModel.id > 0 && !_vm.coordinatorMode)?_c('b-tab',{attrs:{"title":"Cambios"}},[(
					_vm.loadedIndex.includes(
						_vm.$hasPermission('reservation.change.show') ? 3 : 2
					)
				)?_c('TabHistory',{attrs:{"model-id":_vm.viewModel.id}}):_vm._e()],1):_vm._e(),(
				_vm.viewModel.id > 0 &&
					_vm.$hasPermission('reservation.notification.show')
			)?_c('b-tab',{attrs:{"title":"Notificaciones"}},[(
					_vm.loadedIndex.includes(
						_vm.$hasPermission('reservation.notification.show')
							? 4
							: 3
					)
				)?_c('TabMailHistory'):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }